export function customZohoForm() {
    const _custom_btn_black = '<button type="submit" class="button black"><span>submit</span><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.375 2.625V3.5H9.88313L2.625 10.7581L3.24187 11.375L10.5 4.11687V9.625H11.375V2.625H4.375Z" fill="#53CF36"></path></svg></button>';
   
    $('.formsubmit').hide().after(_custom_btn_black);

    $('.zcwf_col_lab').each(function(idx){
        var _name = $(this).find('label').text();
        $(this).siblings('.zcwf_col_fld').find('input, textarea').attr('placeholder', _name);
    });

    $('.zcwf_col_fld select').each(function (idx) {
			var _is_select = $(this).length
			if (_is_select) {
				var _name = $(this).attr('name');
				$(this).siblings('.jcf-select').find('.jcf-select-text span').text(_name + ': -None-');
			}
		});

    $('.zcwf_col_fld select').change(function (idx) {
        var value = $(this).val()
        var _name = $(this).attr('name')
        if (value !== '-None-' && value !== _name + ': -None-') {
            $(this).siblings('.jcf-select').addClass('jcf-active')
        } else {
            $(this).siblings('.jcf-select').removeClass('jcf-active')
        }
    })

    $('.zcwf_col_fld textarea').change(function (idx) {
        var value = $(this).val()
        var _name = $(this).attr('name')
        if (value !== '') {
            $(this).addClass('jcf-active')
        } else {
            $(this).removeClass('jcf-active')
        }
    })

}


// WEBPACK FOOTER //
// ./assets/js/modules/zohoForm.js